"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _useQuery3 = _interopRequireDefault(require("../../../useQuery"));
var _componentsQuery = _interopRequireDefault(require("./componentsQuery.graphql"));
var _ComponentsChartBar = _interopRequireDefault(require("./components/ComponentsChartBar"));
var _round2 = _interopRequireDefault(require("lodash/round"));
var _mean2 = _interopRequireDefault(require("lodash/mean"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var FidelityComponentsChart = function FidelityComponentsChart(props) {
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    hidden = _useState2[0],
    setHidden = _useState2[1];
  var _props$settings = props.settings,
    title = _props$settings.title,
    description = _props$settings.description,
    show = _props$settings.show,
    chart = _props$settings.chart;
  var isPreview = props.isPreview,
    query = props.query;
  var _useQuery = (0, _useQuery3["default"])({
      query: isPreview ? _componentsQuery["default"] : query,
      variables: props.filters
    }),
    _useQuery2 = _slicedToArray(_useQuery, 2),
    data = _useQuery2[0],
    loading = _useQuery2[1];

  // See overallFidelityChart for comments
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      setHidden(false);
    }, 300);
  }, []);
  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  var chartData = props.convertDataStructure(data);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, show && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'bold',
      fontSize: '1.5em'
    }
  }, title)), /*#__PURE__*/_react["default"].createElement("div", null, description), hidden ? /*#__PURE__*/_react["default"].createElement("div", null) : /*#__PURE__*/_react["default"].createElement(_ComponentsChartBar["default"], {
    data: chartData,
    settings: chart
  })));
};
FidelityComponentsChart.propTypes = {
  settings: _propTypes["default"].object,
  isPreview: _propTypes["default"].bool,
  filters: _propTypes["default"].object
};
FidelityComponentsChart.defaultProps = {
  filters: {},
  convertDataStructure: function convertDataStructure(data) {
    // console.log(data);
    var convertedData = [];
    if (data && data.groups.treatmentGroupList.length > 0) {
      var sessionScores = {
        leadership: [[], [], [], [], []],
        foundational: [[], [], [], [], []]
      };
      data.groups.treatmentGroupList.forEach(function (tg) {
        var APL = tg.childRoles.metricspawn.assignmentProgressList;
        var _loop = function _loop(i) {
          var session = APL.find(function (s) {
            return s.deployment.label === "Session ".concat(i + 1);
          });
          if (session) {
            var leadershipScore = session.devTags.FidelityLeadershipScore;
            if (leadershipScore !== null) {
              sessionScores.leadership[i].push(Number(leadershipScore));
            }
            var foundationalScore = session.devTags.FidelityFoundationlElementsScore;
            if (leadershipScore !== null) {
              sessionScores.foundational[i].push(Number(foundationalScore));
            }
          }
        };
        for (var i = 0; i < 5; i++) {
          _loop(i);
        }
      });
      var getAdherenceData = function getAdherenceData(group) {
        var componentsData = {
          metric: group === 'leadership' ? 'Leadership & Group Process' : 'Foundational Elements'
        };
        for (var i = 0; i <= 4; i++) {
          componentsData["Session ".concat(i + 1)] = (0, _round2["default"])((0, _mean2["default"])(sessionScores[group][i]));
        }
        // console.log(componentsData);
        return componentsData;
      };
      convertedData = [getAdherenceData('leadership'), getAdherenceData('foundational')];
    } else {
      convertedData = [{
        metric: 'Foundational Elements',
        'Session 1': 4.3,
        'Session 2': 3.13,
        'Session 3': 4.5,
        'Session 4': 4.1,
        'Session 5': 3.56
      }, {
        metric: 'Leadership & Group Process',
        'Session 1': 4.6,
        'Session 2': 4.3,
        'Session 3': 4.1,
        'Session 4': 4.3,
        'Session 5': 4.5
      }];
    }
    // console.log({ convertedData });
    return convertedData;
  }
};
var _default = exports["default"] = FidelityComponentsChart;